const handleFetchDistrictFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.district = action.payload.data;
    state.message = action.payload.message;
}
const handleDistrictByCountryCodeFulfilled = (state, action) => {
    state.status = 'succeeded';
    state.districtsByCountryCode = action.payload.data;
    state.message = action.payload.message;
};

export {
    handleFetchDistrictFulfilled,
    handleDistrictByCountryCodeFulfilled
};
